var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center col-6 pt-4"},[_c('notifications'),_vm._v(" "),(!_vm.isError)?_c('div',{staticClass:"loader float-right"}):_c('div',{staticClass:"color-red float-left"},[_c('h3',[_vm._v("Operation can not be proccessed")])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f9bba19","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/races/quick-entry/quick-entry.vue
// module id = null
// module chunks = 